module.exports = __webpack_public_path__ + "static/media/aramarkSnackGift.09c804e1.gif";